import { Message } from '../../type';
import { useState } from 'react';
import { ImageListItem, ImageListItemBar } from '@mui/material';
import VideoIcon from '@mui/icons-material/Videocam';
import { useOpenUrl } from '@xolv-mybrightlink/common';

export const MediaGalleryItem = (props: { message: Message }) => {
  const { message } = props;
  const [loaded, setLoaded] = useState(false);
  const openMedia = useOpenUrl(message.url);
  return (
    <ImageListItem onClick={openMedia} sx={{ cursor: 'pointer' }}>
      <img
        src={message.thumbnailUrl}
        alt=''
        loading='lazy'
        onLoad={() => setLoaded(true)}
      />
      {message.messageType === 'VIDEO' && loaded && (
        <ImageListItemBar
          sx={{
            bgcolor: 'transparent',
            '& .MuiImageListItemBar-titleWrap': { pl: 2, py: 0 },
          }}
          title={<VideoIcon />}
        />
      )}
    </ImageListItem>
  );
};
